import React, {useEffect, useState} from "react";
import {Checkbox, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import ButtonExit from "../button/ButtonExit";
import ButtonAdd from "../button/ButtonAdd";
import FormControlLabel from "@mui/material/FormControlLabel";

const ModalWidthCheckbox = ({open, onClose, handleSubmit, title,action,loading}) => {
    const [formState, setFormState] = useState({ignoreSlab: true})

    const handleClose = () => {
        setFormState({ignoreSlab: true})
        onClose()
    }

    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: "400px",
                borderRadius: 8,
            }
        }}>
            <DialogTitle textAlign="center">{title}</DialogTitle>
            <DialogContent>
                <FormControlLabel control={<Checkbox
                    checked={formState.ignoreSlab}
                    onChange={() => setFormState(value => ({
                        ...value,
                        "ignoreSlab": !value.ignoreSlab
                    }))}
                    sx={{marginLeft: "20px"}}
                />} label="Игнорировать плитные"/>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={handleClose}/>
                <ButtonAdd loading={loading} text={action} onClick={() => handleSubmit(formState.ignoreSlab, handleClose)}/>
            </DialogActions>
        </Dialog>
    );
}
export default ModalWidthCheckbox